import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { history } from "store";

import { Button, GlobalErrorMessage } from "shared/components";
import DocumentUploader from "./DocumentUploader";
import DocumentsList from "./DocumentsList";
import EditDocumentAdding from "./EditDocumentAdding";
import { DocumentFolder, DocumentSubFolder, DocumentType, enum_id_docs, } from "shared/enums/DocumentsTypes";
import { WrapMainForm } from "Funnel/Components/WrapPage";

import "./documents.scss";

const InterlocutorDocs = ({ match }) => {
  const isUpdate = match.params.action === "update";
  const dashboard = useSelector((store) => store.dashboard);
  const { docs, moreUploadNeeded } = dashboard.documents.interlocutor;
  const beneficiaries = dashboard.benificiaries.list;
  const hasBeneficiaries = beneficiaries && beneficiaries.length > 0;

  const { id_docs, power_copy } = docs;
  const [notCompleted, setNotCompleted] = useState(false);
  const [edited, setEdited] = useState(null);

  useEffect(() => setNotCompleted(false), [moreUploadNeeded]);

  const handleValidate = async () => {
    if (!moreUploadNeeded) {
      if (isUpdate) {
        history.goBack();
      } else if (hasBeneficiaries) {
        history.push("/beneficiaries-documents");
      } else {
        history.push("/accounts");
      }
    } else {
      setNotCompleted(true);
    }
  };

  return (
    <div className="funnelPgW">
      <div className={`funnelPgContent ${edited ? "rightFormEdited" : ""}`}>
        <div className="funnelPgL">
          <WrapMainForm>
            {!isUpdate && <div className="sectionName">4/4 — Documents</div>}
            <div className="formW">
              <div className="formH">
                <div className="goBack" onClick={() => history.goBack()}>
                  <i className="icon-arrow-back" />
                </div>
                <div className="formTitle">
                  {DocumentFolder.interlocutor.label}
                </div>
              </div>

              <div>
                <div className="docZone">
                  <div className="docTitle">
                    {DocumentSubFolder.id_docs.label}
                  </div>
                  <DocumentsList
                    folder={DocumentFolder.interlocutor.key}
                    subFolder={DocumentSubFolder.id_docs.key}
                    list={id_docs}
                    onAddingClick={() => {
                      setEdited(DocumentSubFolder.id_docs.key);
                    }}
                    active={edited === DocumentSubFolder.id_docs.key}
                    errorClass={notCompleted && id_docs.length === 0}
                  />
                </div>

                <div className="docZone">
                  <div className="docTitle">Mandat de gestion</div>
                  <div>
                    Il s’agit d’un document précisant la délégation des pouvoirs au mandataire pour la gestion de Cashbee Pro
                    et la souscription aux comptes à terme.
                  </div>
                  <DocumentUploader
                    folder={DocumentFolder.interlocutor.key}
                    documentType={DocumentType.power_copy.key}
                    currentItem={power_copy}
                    errorClass={notCompleted && !power_copy}
                  />
                </div>

                {notCompleted && (
                  <div className="docZone">
                    <GlobalErrorMessage>
                      Vous devez ajouter au moins un fichier par document
                      demandé.
                    </GlobalErrorMessage>
                  </div>
                )}

                <Button onClick={handleValidate} variant="contained" primary>
                  {isUpdate ? "Enregistrer" : "Suivant"}
                </Button>
              </div>
            </div>
          </WrapMainForm>
        </div>
        <div className="funnelPgR">
          {edited === DocumentSubFolder.id_docs.key && (
            <EditDocumentAdding
              title={DocumentSubFolder.id_docs.label}
              folder={DocumentFolder.interlocutor.key}
              subFolder={DocumentSubFolder.id_docs.key}
              selectEnum={enum_id_docs}
              close={() => setEdited(null)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InterlocutorDocs;
